import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventDecisionStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            margin: "40px 0px 0px 0px",
        },
        title: { fontWeight: 600, fontSize: "18px" },
        margin: { marginBottom: "20px" },
        btn: {
            padding: "6px 14px 6px 14px",
            marginRight: "10px",
        },
        closeBtn: {
            backgroundColor: "#00AF41",
            color: "black",
            border: "1px solid #00AF41",
            "&:hover": {
                backgroundColor: "#008C34",
                border: "1px solid #008C34",
                color: "black",
            },
        },
        disableCloseBtn: {
            backgroundColor: "rgba(153, 153, 153, 1)",
            color: "black !important",
            border: "1px solid #999999",
        },
        pdfBtn: {
            backgroundColor: "white",
            color: "#00AF41",
            border: "1px solid #00AF41",
            "&:hover": {
                backgroundColor: "#00AF41",
                color: "white",
            },
        },
        disablePdfBtn: {
            backgroundColor: "white",
            color: "rgba(82, 82, 82, 1)  !important",
            border: "1px solid rgba(153, 153, 153, 1)",
        },
        reviewBtn: {
            backgroundColor: "#DF5031",
            color: "black",
            border: "1px solid #DF5031",
            "&:hover": {
                backgroundColor: "#BE442A",
                border: "1px solid #BE442A",

                color: "black",
            },
        },
        disableReviewBtn: {
            backgroundColor: "rgba(153, 153, 153, 1)",
            color: "black",
            border: "1px solid rgba(153, 153, 153, 1)",
        },
        errorText: {
            color: "rgba(223, 80, 49, 1)",
            margin: "15px 0px 15px 0px",
        },
    })
);
